// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.request_global_div{
    width: 50vw;
}
@media (max-width: 600px) {
    .request_global_div{
        width: 85vw;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/ComponentsCss/Global_request_template/Global_request_template.css"],"names":[],"mappings":"AAAA;IACI,WAAW;AACf;AACA;IACI;QACI,WAAW;IACf;AACJ","sourcesContent":[".request_global_div{\n    width: 50vw;\n}\n@media (max-width: 600px) {\n    .request_global_div{\n        width: 85vw;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
